import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import logoImage from '../assets/Logo.png';

function Navbar({ brand, links, cta }) {
  // Use the imported logo from assets
  const logoSrc = logoImage;
  const navigate = useNavigate();
  const location = useLocation();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const handleSolutionsClick = (e) => {
    e.preventDefault();
    if (location.pathname === '/') {
      // If already on home page, just scroll
      const element = document.querySelector('#solutions');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    } else {
      // Navigate to home and then scroll
      navigate('/');
      setTimeout(() => {
        const element = document.querySelector('#solutions');
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 300);
    }
  };

  const handleCtaClick = () => {
    navigate('/demo');
    setIsMobileMenuOpen(false);
  };

  const handleLinkClick = () => {
    setIsMobileMenuOpen(false);
  };

  useEffect(() => {
    // Close mobile menu when route changes
    setIsMobileMenuOpen(false);
  }, [location.pathname]);

  return (
    <>
      {isMobileMenuOpen && (
        <div
          className="mobile-menu-overlay"
          onClick={() => setIsMobileMenuOpen(false)}
        />
      )}
      <nav className="nav">
        <Link to="/" className="brand-link" onClick={handleLinkClick}>
          <div className="brand">
            {logoSrc ? (
              <img className="brand-logo" src={logoSrc} alt={brand.logoAlt || brand.name} />
            ) : (
              <span className="brand-mark">{brand.fallbackMark}</span>
            )}
          </div>
        </Link>
        <button
          className="mobile-menu-toggle"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          aria-label="Toggle menu"
        >
          <span className={isMobileMenuOpen ? 'open' : ''}></span>
          <span className={isMobileMenuOpen ? 'open' : ''}></span>
          <span className={isMobileMenuOpen ? 'open' : ''}></span>
        </button>
        <div className={`nav-links ${isMobileMenuOpen ? 'mobile-open' : ''}`}>
        <Link
          to="/"
          onClick={(e) => {
            e.preventDefault();
            handleLinkClick();
            if (location.pathname !== '/') {
              navigate('/');
            } else {
              window.scrollTo({ top: 0, behavior: 'smooth' });
            }
          }}
          className="mobile-only"
        >
          Home
        </Link>
        <Link
          to="/"
          onClick={(e) => {
            handleSolutionsClick(e);
            handleLinkClick();
          }}
        >
          Solutions
        </Link>
        <Link
          to="/gallery"
          onClick={handleLinkClick}
          className={location.pathname === '/gallery' ? 'active' : ''}
        >
          Gallery
        </Link>
        <Link
          to="/"
          onClick={(e) => {
            e.preventDefault();
            handleLinkClick();
            if (location.pathname === '/') {
              const element = document.querySelector('#technology');
              if (element) {
                element.scrollIntoView({ behavior: 'smooth', block: 'start' });
              }
            } else {
              navigate('/');
              setTimeout(() => {
                const element = document.querySelector('#technology');
                if (element) {
                  element.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }
              }, 300);
            }
          }}
        >
          Technology
        </Link>
        <Link
          to="/products"
          onClick={handleLinkClick}
          className={location.pathname === '/products' ? 'active' : ''}
        >
          Services
        </Link>
        <Link
          to="/"
          onClick={(e) => {
            e.preventDefault();
            handleLinkClick();
            if (location.pathname === '/') {
              const element = document.querySelector('footer#contact');
              if (element) {
                element.scrollIntoView({ behavior: 'smooth', block: 'start' });
              }
            } else {
              navigate('/');
              setTimeout(() => {
                const element = document.querySelector('footer#contact');
                if (element) {
                  element.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }
              }, 300);
            }
          }}
        >
          Contact
        </Link>
      </div>
      <div className={`nav-actions ${isMobileMenuOpen ? 'mobile-open' : ''}`}>
        <button className="nav-cta" onClick={handleCtaClick}>
          {cta}
        </button>
      </div>
    </nav>
    </>
  );
}

export default Navbar;
